import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

/**
 * The following types and constants are repeated here until we devise a nice plan in how we can extract them into a new package
 */
export type DisplacementMode = 'displacement' | 'tracing';

export const VISUALIZER_CATEGORY_KEYS = {
    ANGLES: 'ANGLES',
    SWING_PLANE: 'SWING_PLANE',
    PATHS: 'PATHS',
    JOINT_ANGLES: 'JOINT_ANGLES',
    DISPLACEMENT: 'DISPLACEMENT',
} as const;

export type SelectParams = {
    // Mutually exclusive: only one of Angles, Joint Angles, or Displacement can be selected
    [VISUALIZER_CATEGORY_KEYS.ANGLES]: string | undefined;
    [VISUALIZER_CATEGORY_KEYS.JOINT_ANGLES]: string | undefined;
    [VISUALIZER_CATEGORY_KEYS.DISPLACEMENT]: string | undefined;
    // Multi-select: can have multiple swing planes and paths selected
    [VISUALIZER_CATEGORY_KEYS.SWING_PLANE]: string[];
    [VISUALIZER_CATEGORY_KEYS.PATHS]: string[];
    displacementMode: DisplacementMode;
};

export const EMPTY_SELECT_PARAMS: SelectParams = {
    [VISUALIZER_CATEGORY_KEYS.ANGLES]: undefined,
    [VISUALIZER_CATEGORY_KEYS.JOINT_ANGLES]: undefined,
    [VISUALIZER_CATEGORY_KEYS.DISPLACEMENT]: undefined,
    [VISUALIZER_CATEGORY_KEYS.SWING_PLANE]: [],
    [VISUALIZER_CATEGORY_KEYS.PATHS]: [],
    displacementMode: 'displacement',
};

export type Playback3DViewPreset = 'face_on' | 'down_the_line' | 'top' | 'backside';
export type Playback3DCameraSpherical = {
    azimuthal: number;
    polar: number;
    distance: number;
};
export type Playback3DCameraTarget = {
    x: number;
    y: number;
    z: number;
};

export const playback3dSelectedParamsAtom = atomWithReset<SelectParams>(EMPTY_SELECT_PARAMS);
export const playback3dFreezePositionAtom = atom<string | null>(null);
export const playback3dCurrentViewPresetAtom = atom<Playback3DViewPreset | null>(null);
export const playback3dOverlayComparisonAtom = atom(false);
export const playback3dCameraSphericalAtom = atom<Playback3DCameraSpherical | null>(null);
export const playback3dCameraTargetAtom = atom<Playback3DCameraTarget | null>(null);
